<script setup lang="ts">
import {
  EnumerationEvaluationOptionDto,
  EnumerationEvaluationParameterDto,
  EnumerationEvaluationResultDto,
} from '@/api/generator';
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import { computed } from 'vue';

const props = defineProps<{
  evaluation: EnumerationEvaluationParameterDto;
  result?: EnumerationEvaluationResultDto;
  disabled?: boolean;
}>();

const emits = defineEmits<{
  input: [result: EnumerationEvaluationOptionDto];
}>();

const options = computed(
  () => props.evaluation.options?.filter((option) => option.isEnabled) ?? [],
);

const selectedOption = computed(() =>
  options.value?.find((option) => option.id === props.result?.selectedOption?.id),
);

function select(option: EnumerationEvaluationOptionDto | null) {
  if (option) {
    emits('input', option);
  }
}
</script>

<template>
  <FormLabel :label="$t('ManualInput')">
    <v-radio-group
      :modelValue="selectedOption"
      :disabled="disabled"
      @update:modelValue="select($event)"
    >
      <v-radio
        v-for="option in options"
        :key="option.id"
        :label="option.name ?? ''"
        :value="option"
        class="align-start"
      />
    </v-radio-group>
  </FormLabel>
</template>
